<template>
  <div class="chart b-r">
    <div class="top">
      <div class="top_l">
        <slot name="title"></slot>
      </div>
      <div class="top_r" @click="edit">
        <span><i class="el-icon-edit-outline"></i></span>
        <span>编辑</span>
      </div>
    </div>
    <div class="tab">
      <slot name="tab"></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    path: String,
  },
  data() {
    return {};
  },
  computed: {},
  created() {},
  mounted() {},
  watch: {},
  methods: {
    edit() {
      this.$go(this.path, { actions: "edit" });
    },
  },
  components: {},
};
</script>

<style lang="less" scoped>
.chart {
  width: 100%;
  padding: 0.22rem 0.13rem;
  margin-top: 0.2rem;
  .top {
    display: flex;
    justify-content: space-between;
    .top_r {
      cursor: pointer;
      span {
        color: #67c23a;
      }
    }
  }
  .tab {
    table {
      margin-top: 0.2rem;
    }
  }
}
@media only screen and (max-width: 766px) {
  .chart {
    width: 95%;
    margin: 0 auto;
    margin-top: 0.2rem;
  }
}
</style>
